import React from 'react';
import { Switch } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PrivateRoute from 'app/shared/auth/private-route';
import Ecole from './ecole';
import Classe from './classe';
import Eleve from './eleve';
import Uploads from './uploads';
import Parent from './parent';
import Surveillant from './surveillant';
import Directeur from './directeur';
import Professeur from './personnel';
import Notification from './notification';
import Support from './support';
import MatiereEcole from './matiere-ecole';
import Cycle from './cycle';
import PeriodeEvaluation from './periode-evaluation';
import PedagogieConfig from './pedagogie-config';
import { PedagogieWizardPage } from './pedagogie-config/PedagogieWizard';
import Evaluation from './evaluation';
import Notes from './notes';
import Comptable from './comptable';
import { AUTHORITIES } from 'app/config/constants';
import Scolarite from './scolarite';
import Virement from './virement';
import Salaire from './salaire';
import Finances from './finances';
import EcoleConfig from './ecoleConfig';
import Approvisonnement from './approvisonnements';
import AnneeScolaire from './annee-scolaire';
import Calendar from './calendar';
import Transaction from './transaction';
import BulletinBranding from './bulletin-branding';
import ControleAcces from './controle-acces';

const COMMON_AUTHORITIES = [
  AUTHORITIES.ADMIN,
  AUTHORITIES.DIRECTEUR,
  AUTHORITIES.COMPTABLE,
  AUTHORITIES.DIRECTEUR_ETUDE,
  AUTHORITIES.SURVEILLANT,
  AUTHORITIES.SURVEILLANT_GENERAL,
  AUTHORITIES.SECRETAIRE,
];
const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      <PrivateRoute path={`${match.url}ecole`} component={Ecole} hasAnyAuthorities={COMMON_AUTHORITIES}/>
      <PrivateRoute path={`${match.url}eleve`} component={Eleve} hasAnyAuthorities={COMMON_AUTHORITIES} />
      <PrivateRoute
        path={`${match.url}controle-acces`}
        component={ControleAcces}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR, AUTHORITIES.DIRECTEUR_ETUDE, AUTHORITIES.SURVEILLANT_GENERAL]}
      />
      <PrivateRoute path={`${match.url}uploads`} component={Uploads} hasAnyAuthorities={COMMON_AUTHORITIES} />
      <PrivateRoute path={`${match.url}classe`} component={Classe} hasAnyAuthorities={[...COMMON_AUTHORITIES, AUTHORITIES.PROFESSEUR]} />
      <PrivateRoute path={`${match.url}surveillant`} component={Surveillant} hasAnyAuthorities={COMMON_AUTHORITIES} />
      <PrivateRoute path={`${match.url}parent`} component={Parent} hasAnyAuthorities={COMMON_AUTHORITIES} />
      <PrivateRoute path={`${match.url}directeur`} component={Directeur} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR]} />
      <ErrorBoundaryRoute path={`${match.url}personnel`} component={Professeur} />
      <ErrorBoundaryRoute path={`${match.url}notification`} component={Notification} />
      <ErrorBoundaryRoute path={`${match.url}scolarite`} component={Scolarite} />
      <ErrorBoundaryRoute path={`${match.url}matiere-ecole`} component={MatiereEcole} />
      <ErrorBoundaryRoute path={`${match.url}configuration-pedagogie/:ecoleid/wizard/:cycleId?`} component={PedagogieWizardPage} />
      <ErrorBoundaryRoute exact path={`${match.url}configuration-pedagogie/:ecoleid`} component={PedagogieConfig} />
      <ErrorBoundaryRoute path={`${match.url}cycle`} component={Cycle} />
      <ErrorBoundaryRoute path={`${match.url}periode-evaluation`} component={PeriodeEvaluation} />
      <ErrorBoundaryRoute path={`${match.url}evaluation`} component={Evaluation} />
      <ErrorBoundaryRoute path={`${match.url}notes`} component={Notes} />
      <PrivateRoute
        exact
        path={`${match.url}parametres-bulletin/:ecoleid`}
        component={BulletinBranding}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR, AUTHORITIES.DIRECTEUR_ETUDE]}
      />
      <ErrorBoundaryRoute path={`${match.url}virements`} component={Virement} />
      <ErrorBoundaryRoute path={`${match.url}approvisonnements`} component={Approvisonnement} />
      <ErrorBoundaryRoute path={`${match.url}finances`} component={Finances} />
      <ErrorBoundaryRoute path={`${match.url}salaires`} component={Salaire} />
      <ErrorBoundaryRoute path={`${match.url}support`} component={Support} />
      <ErrorBoundaryRoute path={`${match.url}comptable`} component={Comptable} />
      <PrivateRoute path={`${match.url}ecole-config`} component={EcoleConfig} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <ErrorBoundaryRoute path={`${match.url}annee-scolaire`} component={AnneeScolaire} />
      <ErrorBoundaryRoute path={`${match.url}calendar`} component={Calendar} />
      <ErrorBoundaryRoute path={`${match.url}transaction`} component={Transaction} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
  </div>
);

export default Routes;
